import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ConvexClientProvider } from "./auth/ConvexClientProvider";
import { AuthProvider } from "./auth/AuthContext";
import { registerServiceWorker } from "./lib/webPushRegistration";
import { initAnalytics } from "./lib/analytics";
import { initWebSentry } from "./lib/sentry";

initAnalytics();
void initWebSentry();

// Register service worker for web push (non-blocking)
if ("serviceWorker" in navigator) {
  registerServiceWorker().catch(() => {});
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConvexClientProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConvexClientProvider>
  </StrictMode>,
);
